import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Setting } from '../models/setting.model';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  constructor(private httpClient: HttpClient) { }

  // Version publique des réglages : clé VAPID publique et email de contact (GET /settings est réservé au back office)
  getAllSettings(): Observable<Setting[]> {
    const host = environment.host;

    return this.httpClient.get<Setting[]>(host + '/settings/public');
  }
}
